import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { html, css, LitElement } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { svgWithJs, variables } from '../variables';

import '../icons/icon/apt-icon'
import { faMessageLines } from '@fortawesome/pro-regular-svg-icons';

@customElement('apt-notes-button')
export class AptNotesButton extends LitElement {

  @property({ type: Boolean }) disabled = false;

  @state() position = 'top';

  static override get styles() {
    return [
      variables,
      svgWithJs,
      css`
        :host {
          font-size: small;
          color: var(--gray-800);
          min-width: auto;
          max-width: fit-content;
          display: flex;
          flex-direction: column;
          background-color: transparent;
          user-select: none;
          cursor: pointer;
          --font-color: #979797;
        }
        .box {
              display: inline-flex;
            min-height: 0px;
            padding-top: 0px;
            box-sizing: border-box;
            border: 1px solid var(--gray-300);
            width: 24px;
            align-items: center;
            font-weight: 400;
            padding-left: 4px;
            margin-right: -5px;
            padding-right: 0px;
            padding-bottom: 4px;
            padding-top: 4px;
            border-radius: 5px;
        }

        .box:hover{
           background-color: var(--gray-200);
        }

        .disabled{
          background-color: var(--gray-200);
          cursor: not-allowed; 
        }
        
      `,
    ];
  }

  getIcon() {
    return html`<i class="fa-regular fa-message-lines "></i>`;

  }

  override render() {
    return html`
      <span class="box ${this.disabled ? 'disabled' : ''}" @click="${() => this.handleClick()}" >
          ${this.getIcon()}
      </span>
    
    </div>
    `;
  }

  handleClick() {
    if (!this.disabled) {
      this.dispatchEvent(new window.CustomEvent('open-notes', { composed: true, bubbles: true, detail: '' }));
    }

  }

  protected override firstUpdated(): void {

    library.add(faMessageLines);
    // @ts-expect-error The dom.watch() TS definition indicates no parameters for this. However, when
    // you actually dig into the code, you see that it looks at the arguments after it gets into
    // the code and tries to pull some out if there aren't any (it even supplies an empty object
    // for options if you don't supply one yourself).
    //
    // Note: We have to wait for the first update for the shadow DOM to even be created.
    dom.watch({
      autoReplaceSvgRoot: this.shadowRoot,
      observeMutationsRoot: this.shadowRoot,
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'apt-notes-button': AptNotesButton;
  }
}